module.exports = __webpack_public_path__ + "static/media/Staraptor_gaussian2.0a731286.png";